import { render, staticRenderFns } from "./settingLayout.vue?vue&type=template&id=7c97c723&scoped=true&"
import script from "./settingLayout.vue?vue&type=script&lang=js&"
export * from "./settingLayout.vue?vue&type=script&lang=js&"
import style0 from "./settingLayout.vue?vue&type=style&index=0&id=7c97c723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c97c723",
  null
  
)

export default component.exports